import ApplicationFeesInfo from '@/components/ModalRenderer/components/SE/ApplicationFeesInfo';
import BankAccountUpdateInProgress from '@/components/ModalRenderer/components/SE/BankAccountUpdateInProgress';
import ConfirmLeaveCreditOffer from '@/components/ModalRenderer/components/SE/ConfirmLeaveCreditOffer';
import ConfirmReactivateIdProtect from '@/components/ModalRenderer/components/SE/ConfirmReactivateIdProtect';
import ConfirmReactivatePaymentProtectionInsurance from '@/components/ModalRenderer/components/SE/ConfirmReactivatePaymentProtectionInsurance';
import ConfirmTerminatePaymentProtectionInsurance from '@/components/ModalRenderer/components/SE/ConfirmTerminatePaymentProtectionInsurance';
import CreditAgreement from '@/components/ModalRenderer/components/SE/CreditAgreement';
import CreditTierMigrationSuccess from '@/components/ModalRenderer/components/SE/CreditTierMigrationSuccess';
import DirectDebitTerms from '@/components/ModalRenderer/components/SE/DirectDebitTerms';
import DirectPaymentOrderNotFound from '@/components/ModalRenderer/components/SE/DirectPaymentOrderNotFound';
import EmailVerification from '@/components/ModalRenderer/components/SE/EmailVerification';
import EmailVerificationOtp from '@/components/ModalRenderer/components/SE/EmailVerificationOtp';
import EmailVerificationSuccess from '@/components/ModalRenderer/components/SE/EmailVerificationSuccess';
import IdProtectCampaignModal from '@/components/ModalRenderer/components/SE/IdProtectCampaignModal';
import IdProtectInfo from '@/components/ModalRenderer/components/SE/IdProtectInfo';
import IdProtectReactivateSuccess from '@/components/ModalRenderer/components/SE/IdProtectReactivateSuccess';
import IdProtectSignupSuccess from '@/components/ModalRenderer/components/SE/IdProtectSignupSuccess';
import IdProtectTerms from '@/components/ModalRenderer/components/SE/IdProtectTerms';
import InsufficientFunds from '@/components/ModalRenderer/components/SE/InsufficientFunds';
import LoanAgreement from '@/components/ModalRenderer/components/SE/LoanAgreement';
import LoanIdProtectAgreement from '@/components/ModalRenderer/components/SE/LoanIdProtectAgreement';
import LoanIdProtectTermination from '@/components/ModalRenderer/components/SE/LoanIdProtectTermination';
import LoanIdProtectTerminationInGracePeriod from '@/components/ModalRenderer/components/SE/LoanIdProtectTerminationInGracePeriod';
import LoanPartnerAgreement from '@/components/ModalRenderer/components/SE/LoanPartnerAgreement';
import LoanWithdrawalFailed from '@/components/ModalRenderer/components/SE/LoanWithdrawalFailed';
import LoanWithdrawalSuccess from '@/components/ModalRenderer/components/SE/LoanWithdrawalSuccess';
import MigrationToNewTierNeeded from '@/components/ModalRenderer/components/SE/MigrationToNewTierNeeded';
import MobileVerification from '@/components/ModalRenderer/components/SE/MobileVerification';
import OpenBankingInfo from '@/components/ModalRenderer/components/SE/OpenBankingInfo';
import OpenBankingRecoveryCancellation from '@/components/ModalRenderer/components/SE/OpenBankingRecoveryCancellation';
import OpenBankingRecoveryInfo from '@/components/ModalRenderer/components/SE/OpenBankingRecoveryInfo';
import OverduePayment from '@/components/ModalRenderer/components/SE/OverduePayment';
import PaymentFreeMonthWithdrawalBlocked from '@/components/ModalRenderer/components/SE/PaymentFreeMonthWithdrawalBlocked';
import PaymentProtectionInsuranceReactivateSuccess from '@/components/ModalRenderer/components/SE/PaymentProtectionInsuranceReactivateSuccess';
import PaymentProtectionInsuranceSuccess from '@/components/ModalRenderer/components/SE/PaymentProtectionInsuranceSuccess';
import PaymentProtectionInsuranceTerms from '@/components/ModalRenderer/components/SE/PaymentProtectionInsuranceTerms';
import PaymentProtectionInsuranceToBeTerminated from '@/components/ModalRenderer/components/SE/PaymentProtectionInsuranceToBeTerminated';
import PrivacyPolicy from '@/components/ModalRenderer/components/SE/PrivacyPolicy';
import RemainingDebtInfoLoanIdProtect from '@/components/ModalRenderer/components/SE/RemainingDebtInfoLoanIdProtect';
import RemainingDebtInfoLoanIdProtectInGracePeriod from '@/components/ModalRenderer/components/SE/RemainingDebtInfoLoanIdProtectInGracePeriod';
import SekkiCreditPartner from '@/components/ModalRenderer/components/SE/SekkiCreditPartner';
import TermsAndConditionsPartner from '@/components/ModalRenderer/components/SE/TermsAndConditionsPartner';
import WithdrawalIpAddressCheck from '@/components/ModalRenderer/components/SE/WithdrawalIpAddressCheck';
import WithdrawalSuccess from '@/components/ModalRenderer/components/SE/WithdrawalSuccess';

const SE = {
  APPLICATION_FEES_INFO: ApplicationFeesInfo,
  BANK_ACCOUNT_UPDATE_IN_PROGRESS: BankAccountUpdateInProgress,
  CONFIRM_LEAVE_CREDIT_OFFER: ConfirmLeaveCreditOffer,
  CONFIRM_REACTIVATE_ID_PROTECT: ConfirmReactivateIdProtect,
  CONFIRM_REACTIVATE_PAYMENT_PROTECTION_INSURANCE: ConfirmReactivatePaymentProtectionInsurance,
  CONFIRM_TERMINATE_PAYMENT_PROTECTION_INSURANCE: ConfirmTerminatePaymentProtectionInsurance,
  CREDIT_AGREEMENT: CreditAgreement,
  CREDIT_TIER_MIGRATION_SUCCESS: CreditTierMigrationSuccess,
  DIRECT_PAYMENT_ORDER_NOT_FOUND: DirectPaymentOrderNotFound,
  EMAIL_VERIFICATION: EmailVerification,
  EMAIL_VERIFICATION_OTP: EmailVerificationOtp,
  EMAIL_VERIFICATION_SUCCESS: EmailVerificationSuccess,
  ID_PROTECT_CAMPAIGN: IdProtectCampaignModal,
  ID_PROTECT_REACTIVATE_SUCCESS: IdProtectReactivateSuccess,
  ID_PROTECT_SIGNUP_SUCCESS: IdProtectSignupSuccess,
  ID_PROTECT_INFO: IdProtectInfo,
  ID_PROTECT_TERMS: IdProtectTerms,
  INSUFFICIENT_FUNDS: InsufficientFunds,
  LOAN_ID_PROTECT_TERMINATION_IN_GRACE_PERIOD: LoanIdProtectTerminationInGracePeriod,
  LOAN_ID_PROTECT_TERMINATION: LoanIdProtectTermination,
  LOAN_WITHDRAWAL_FAILED: LoanWithdrawalFailed,
  LOAN_WITHDRAWAL_SUCCESS: LoanWithdrawalSuccess,
  REMAINING_DEBT_INFO_LOAN_ID_PROTECT_IN_GRACE_PERIOD: RemainingDebtInfoLoanIdProtectInGracePeriod,
  REMAINING_DEBT_INFO_LOAN_ID_PROTECT: RemainingDebtInfoLoanIdProtect,
  SEKKI_CREDIT_PARTNER: SekkiCreditPartner,
  MIGRATION_TO_NEW_TIER_NEEDED: MigrationToNewTierNeeded,
  MOBILE_VERIFICATION: MobileVerification,
  OPEN_BANKING_INFO: OpenBankingInfo,
  OPEN_BANKING_RECOVERY_CANCELLATION: OpenBankingRecoveryCancellation,
  OPEN_BANKING_RECOVERY_INFO: OpenBankingRecoveryInfo,
  OVERDUE_PAYMENT: OverduePayment,
  PAYMENT_FREE_MONTH_WITHDRAWAL_BLOCKED: PaymentFreeMonthWithdrawalBlocked,
  PAYMENT_PROTECTION_INSURANCE_REACTIVATE_SUCCESS: PaymentProtectionInsuranceReactivateSuccess,
  PAYMENT_PROTECTION_INSURANCE_SUCCESS: PaymentProtectionInsuranceSuccess,
  PAYMENT_PROTECTION_INSURANCE_TERMS: PaymentProtectionInsuranceTerms,
  PAYMENT_PROTECTION_INSURANCE_TO_BE_TERMINATED: PaymentProtectionInsuranceToBeTerminated,
  PRIVACY_POLICY: PrivacyPolicy,
  TERMS_AND_CONDITIONS_PARTNER: TermsAndConditionsPartner,
  WITHDRAWAL_IP_ADDRESS_CHECK: WithdrawalIpAddressCheck,
  WITHDRAWAL_SUCCESS: WithdrawalSuccess,
  LOAN_AGREEMENT: LoanAgreement,
  LOAN_ID_PROTECT_AGREEMENT: LoanIdProtectAgreement,
  LOAN_PARTNER_AGREEMENT: LoanPartnerAgreement,
  DIRECT_DEBIT_TERMS: DirectDebitTerms,
} as const;

export default SE;
